import { STRONGHOLD_UPGRADE_REACTIVE } from 'channels/clan/actions'

import {
    STRONGHOLD_LOAD_REQUEST,
    STRONGHOLD_LOAD_SUCCESS,
    STRONGHOLD_LOAD_ERROR,
} from '../actions/stronghold'

import {
    COMMAND_CENTER_UPGRADE_SUCCESS,
} from '../actions/command_center_upgrade'

import { CLAN_LANDING_REQUEST_SUCCESS } from '../actions/clan_landing'

const initialState = {
    loading: false,
    loaded: false,
    errorMessage: '',
    id: null,
    level: 1,
    arena: null,
    clan: null,
    stats: null,
}

export default function stronghold(state = initialState, action = {}) {
    switch (action.type) {
    case STRONGHOLD_LOAD_REQUEST: {
        return {
            ...state,
            loading: true,
            errorMessage: '',
        }
    }
    case STRONGHOLD_LOAD_ERROR: {
        return {
            ...state,
            loading: false,
            loaded: true,
            errorMessage: action.payload.errorMessage,
        }
    }
    case STRONGHOLD_LOAD_SUCCESS: {
        return {
            ...state,
            loading: false,
            loaded: true,
            ...action.payload,
        }
    }
    case STRONGHOLD_UPGRADE_REACTIVE:
    case CLAN_LANDING_REQUEST_SUCCESS:
    case COMMAND_CENTER_UPGRADE_SUCCESS: {
        return {
            ...state,
            level: action.payload.level,
        }
    }
    default:
        return state
    }
}



// WEBPACK FOOTER //
// ./state/reducers/stronghold.js